import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Users, Trophy, Camera, X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';
import { juniorsTeams } from '../data/interclubs';

const galleryPhotos = [
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/sumgc5uf_WhatsApp%20Image%202026-06-14%20at%2017.36.40%20%282%29.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/umv98ff8_WhatsApp%20Image%202026-06-14%20at%2017.36.40%20%283%29.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/345y9dh8_WhatsApp%20Image%202026-06-14%20at%2017.36.40%20%284%29.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/80qyf635_WhatsApp%20Image%202026-06-14%20at%2017.36.41.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/herb2pwr_WhatsApp%20Image%202026-06-14%20at%2017.36.41%20%281%29.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/b17xjv0k_WhatsApp%20Image%202026-06-14%20at%2017.36.40.jpeg',
  'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/qy192fa5_WhatsApp%20Image%202026-06-14%20at%2017.36.40%20%281%29.jpeg',
];

function TeamSection({ team }) {
  const isCheyres = (name) => name.includes('Cheyres');

  return (
    <div className="mb-14">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{team.fullTitle}</h2>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Résultats */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
            <Calendar className="w-5 h-5 text-blue-600 mr-2" />
            Résultats
          </h3>
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 text-center text-gray-600">Tour</th>
                  <th className="px-3 py-2 text-center text-gray-600">Date</th>
                  <th className="px-3 py-2 text-left text-gray-600">Rencontre</th>
                  <th className="px-3 py-2 text-center text-gray-600">Score</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {team.matches.map((match, idx) => {
                  const hasCheyres = isCheyres(match.home) || isCheyres(match.away);
                  const dateLabel = match.time ? `${match.date} - ${match.time}` : match.date;
                  return (
                    <tr key={idx} className={hasCheyres ? 'bg-yellow-50' : 'hover:bg-gray-50'}>
                      <td className="px-3 py-2.5 text-center">{match.tour}</td>
                      <td className="px-3 py-2.5 text-center">{dateLabel}</td>
                      <td className={`px-3 py-2.5 ${hasCheyres ? 'font-semibold text-green-700' : ''}`}>
                        {match.home} - {match.away}
                      </td>
                      <td className="px-3 py-2.5 text-center font-semibold">{match.score}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Classement */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
            <Trophy className="w-5 h-5 text-blue-600 mr-2" />
            Classement
          </h3>
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 text-center text-gray-600">Rang</th>
                  <th className="px-3 py-2 text-left text-gray-600">Équipe</th>
                  <th className="px-3 py-2 text-center text-gray-600">PT</th>
                  <th className="px-3 py-2 text-center text-gray-600">SET</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {team.standings.map((row, idx) => (
                  <tr key={idx} className={isCheyres(row.team) ? 'bg-yellow-50' : 'hover:bg-gray-50'}>
                    <td className="px-3 py-2.5 text-center font-semibold">{row.rank}</td>
                    <td className={`px-3 py-2.5 ${isCheyres(row.team) ? 'font-bold text-green-700' : ''}`}>
                      {row.team}
                    </td>
                    <td className="px-3 py-2.5 text-center">{row.pts}</td>
                    <td className="px-3 py-2.5 text-center">{row.sets}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function PhotoGallery({ photos }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (idx) => setLightboxIndex(idx);
  const closeLightbox = () => setLightboxIndex(null);
  const next = () => setLightboxIndex((i) => (i + 1) % photos.length);
  const prev = () => setLightboxIndex((i) => (i - 1 + photos.length) % photos.length);

  return (
    <div className="mb-12">
      <div className="flex items-center gap-3 mb-6">
        <Camera className="w-6 h-6 text-blue-600" />
        <h2 className="text-2xl font-bold text-gray-900">Nos juniors en action</h2>
      </div>
      <p className="text-gray-600 mb-6">Quelques moments capturés par les équipes pendant les Interclubs 2026.</p>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2">
        {photos.map((src, idx) => (
          <div
            key={idx}
            onClick={() => openLightbox(idx)}
            data-testid={`junior-gallery-photo-${idx}`}
            className="relative group cursor-pointer rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 aspect-square bg-gray-100"
          >
            <img
              src={src}
              alt={`Photo juniors ${idx + 1}`}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
              <ZoomIn className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
          data-testid="junior-gallery-lightbox"
        >
          <button
            onClick={closeLightbox}
            data-testid="junior-gallery-close"
            className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            aria-label="Fermer"
          >
            <X className="w-7 h-7" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            data-testid="junior-gallery-prev"
            className="absolute left-4 text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            aria-label="Précédent"
          >
            <ChevronLeft className="w-8 h-8" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            data-testid="junior-gallery-next"
            className="absolute right-4 text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            aria-label="Suivant"
          >
            <ChevronRight className="w-8 h-8" />
          </button>

          <div className="max-w-5xl max-h-[85vh] w-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={photos[lightboxIndex]}
              alt={`Photo juniors ${lightboxIndex + 1}`}
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />
            <div className="mt-3 text-white text-sm bg-black/50 px-4 py-2 rounded-full">
              <span className="opacity-75">{lightboxIndex + 1} / {photos.length}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const InterclubsJuniorsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header scrollY={100} />

      <div className="pt-24 pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="mb-10">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-2">
              Interclubs Juniors 2026
            </h1>
            <p className="text-lg text-gray-500">
              Championnat interclubs Swiss Tennis - Saison 2026
            </p>
          </div>

          {/* Nos équipes */}
          <div className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Users className="w-6 h-6 text-blue-600 mr-2" />
              Nos 3 équipes
            </h2>
            <div className="grid sm:grid-cols-3 gap-4">
              {juniorsTeams.map((team) => (
                <div key={team.id} className="bg-white rounded-xl shadow-md p-5 border-l-4 border-blue-500">
                  <p className="font-bold text-gray-900">{team.fullTitle}</p>
                  <p className="text-sm text-gray-500">{team.category}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Sections par équipe */}
          {juniorsTeams.map((team) => (
            <TeamSection key={team.id} team={team} />
          ))}

          <p className="text-sm text-gray-500 flex items-center mb-12">
            <span className="inline-block w-4 h-3 bg-yellow-100 border border-yellow-400 rounded mr-2"></span>
            Matchs / lignes de Cheyres-Châbles
          </p>

          {/* Galerie photo */}
          <PhotoGallery photos={galleryPhotos} />
        </div>
      </div>

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />

      <Footer />
    </div>
  );
};

export default InterclubsJuniorsPage;
